import React from 'react'
import PropTypes from 'prop-types'

const Jsonld = ({ id, dataSchema, dataQa }) => {
  if (!dataSchema) return null

  return (
    <script
      id={id}
      data-qa={dataQa}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(dataSchema).replace(/</g, '\\u003c'),
      }}
    />
  )
}

Jsonld.propTypes = {
  id: PropTypes.string.isRequired,
  dataQa: PropTypes.string.isRequired,
  dataSchema: PropTypes.oneOfType([PropTypes.object]),
}

Jsonld.defaultProps = {
  dataSchema: undefined,
}

export default Jsonld
